import { createContext, useContext } from 'react';
export const RadioGroupContext = createContext(undefined);
export function useRadioGroup() {
    const context = useContext(RadioGroupContext);
    if (!context) {
        throw new Error(`useRadioOption hook cannot be used outside the RadioGroup context`);
    }
    return context;
}
//# sourceMappingURL=useRadioGroup.js.map